module.exports = __webpack_public_path__ + "img/foto.3c8f6303.png";